module.exports = __webpack_public_path__ + "img/Linkedin.84c47a71.png";